import { AllocationProtocolDTO } from "./allocationProtocolDTO";

export class AllocationDefinitionDTO{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinitionId!: number;
    public allocationProtocols!: AllocationProtocolDTO[];
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: string;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;

    constructor(){
        this.allocationProtocols = new Array();
    }
}